import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('costCenterTransfers', app)
  return store
}
